import axios from "axios";
import { getRotaPath } from "../lib/white-cache";

export const deleteExtraSharedUser = async (id: string): Promise<boolean> => {
  try {
    await axios.delete(`${getRotaPath()}/ExtraSharedCalendarUser/${id}`);
    return true;
  } catch (error) {
    return false;
  }
};
